function Section({ header, children }) {

    return (
        <div className="results-block">
            <div className="results-header">
                {header}
            </div>
            {children}
        </div>
    )
}

export default Section;